import { FC } from 'react';
import { SubmissionErrorBoundary } from '../../../components/errors/SubmissionErrorBoundary';
import { Modal } from '../../../components/shared/modal/Modal';
import strings from '../team.translations';
import { OnboardingContents, OnboardingUserData } from './OnboardingContents';

interface OnboardingModalProps {
  user: OnboardingUserData;
  open: boolean;
  onClose: () => void;
}

export const OnboardingModal: FC<OnboardingModalProps> = ({ user, open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose} header={strings.onboarding.button}>
      <SubmissionErrorBoundary>
        <OnboardingContents user={user} onClose={onClose} />
      </SubmissionErrorBoundary>
    </Modal>
  );
};
